import React from "react";
import { InputProps } from "../../utils/types";
import FormikInputField from "common/components/dataEntry/formik/FormikInputField";

export function Text(props: InputProps) {
	return <FormikInputField label={props.title} name={props.name} />;
}
